import React from 'react';
import { Link } from 'react-router-dom';
import './WayHomePrivacyPage.css';

const WayHomeTermsPage: React.FC = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <section className="privacy-hero">
          <h1>Terms of Service</h1>
          <p className="privacy-meta">Way Home — Last updated: August 23, 2026</p>
        </section>

        <article className="privacy-card">
          <p>
            These Terms of Service (&quot;Terms&quot;) govern your use of the Way Home game
            (&quot;App&quot;) provided by SynorLab (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;).
            By downloading, installing, or using the App, you agree to these Terms. If you do not agree,
            do not use the App.
          </p>
          <p>
            Please also read our{' '}
            <Link to="/wayhome/privacy">Privacy Policy</Link>, which explains how we handle your data.
          </p>

          <h2>1. Description of Service</h2>
          <p>
            Way Home is a puzzle adventure game. You place triggers, guide a character through
            obstacles, collect stars, and progress through levels. Features may include level
            content, progress stored on your device, and advertisements.
          </p>

          <h2>2. License and Acceptable Use</h2>
          <p>
            We grant you a limited, non-exclusive, non-transferable, revocable license to use the App for
            personal, non-commercial purposes, subject to these Terms and applicable app store rules.
          </p>
          <p>You agree not to:</p>
          <ul>
            <li>Use the App for any unlawful purpose or in violation of any applicable laws</li>
            <li>Reverse engineer, decompile, or attempt to extract the source code of the App</li>
            <li>Interfere with or disrupt the App&apos;s functionality or security features</li>
            <li>Remove or alter any proprietary notices in the App</li>
          </ul>

          <h2>3. Progress and Data</h2>
          <p>
            Game progress is stored on your device unless a feature you choose uses a third-party
            service. We are not responsible for data loss caused by device failure, uninstallation,
            or operating system changes. You use the App at your own risk.
          </p>

          <h2>4. Advertising</h2>
          <p>
            The App may display advertisements through Google AdMob or similar providers. Ad delivery
            and related data practices are governed by those providers&apos; policies. See our{' '}
            <Link to="/wayhome/privacy">Privacy Policy</Link> for details.
          </p>

          <h2>5. Intellectual Property</h2>
          <p>
            The App, including its design, code, graphics, and branding, is owned by SynorLab and
            protected by intellectual property laws.
          </p>

          <h2>6. Disclaimer of Warranties</h2>
          <p>
            THE APP IS PROVIDED &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; WITHOUT WARRANTIES OF ANY KIND,
            WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY,
            FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE APP WILL
            BE UNINTERRUPTED, ERROR-FREE, OR FREE OF HARMFUL COMPONENTS.
          </p>

          <h2>7. Limitation of Liability</h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, SYNORLAB AND ITS DEVELOPERS SHALL NOT BE
            LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS
            OF DATA, PROFITS, OR GOODWILL, ARISING FROM YOUR USE OF OR INABILITY TO USE THE APP.
          </p>
          <p>
            Our total liability for any claim arising from these Terms or your use of the App shall not
            exceed the amount you paid for the App in the twelve (12) months preceding the claim, or
            zero if the App was provided free of charge.
          </p>

          <h2>8. Updates and Changes</h2>
          <p>
            We may update the App or these Terms from time to time. Continued use of the App after
            changes take effect constitutes acceptance of the revised Terms. We will update the
            &quot;Last updated&quot; date when changes are made.
          </p>

          <h2>9. Termination</h2>
          <p>
            You may stop using the App at any time by uninstalling it from your device. We may suspend
            or discontinue the App or your access to it if you violate these Terms.
          </p>

          <h2>10. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with applicable laws, without
            regard to conflict-of-law principles. Any disputes shall be resolved in the courts of
            competent jurisdiction.
          </p>

          <h2>11. Contact Us</h2>
          <p>
            If you have any questions about these Terms, you can contact us by email:{' '}
            <a href="mailto:synorlab.com@gmail.com">synorlab.com@gmail.com</a>
          </p>
        </article>

        <div className="privacy-back">
          <Link to="/wayhome" className="privacy-back-link">← Back to Way Home</Link>
        </div>
      </div>
    </div>
  );
};

export default WayHomeTermsPage;
